// frontend/admin-portal/src/components/dashboard/StatCard.jsx
import React from "react";
import { Spinner, Panel } from "@fiberhome/shared-ui";

export default function StatCard({
  label,
  value,
  subValue,
  loading,
  error,
  icon,
  tone = "primary",
  onClick,
}) {
  const cls = ["fh-kpi", `fh-kpi--${tone}`, onClick ? "fh-kpi--clickable" : ""]
    .filter(Boolean)
    .join(" ");

  return (
    <div
      className={cls}
      onClick={onClick}
      role={onClick ? "button" : undefined}
    >
      <div className="fh-kpi__body">
        <div className="fh-kpi__label">{label}</div>
        {loading ? (
          <div style={{ marginTop: 8 }}>
            <Spinner size="sm" />
          </div>
        ) : error ? (
          <div className="fh-kpi__value" style={{ fontSize: 16 }}>
            —
          </div>
        ) : (
          <>
            <div className="fh-kpi__value">{value ?? "—"}</div>
            {subValue && <div className="fh-kpi__sub">{subValue}</div>}
          </>
        )}
      </div>
      {icon && <div className="fh-kpi__icon">{icon}</div>}
    </div>
  );
}
